export default __webpack_public_path__ + "static/media/img-seg.08cdd64b.jpg";